export const testimonials = {
  it: {
    title: "Cosa Dicono Clienti e Collaboratori",
    subtitle: "Scelto da leader nei settori tech, farmaceutico, manifatturiero e della consulenza.",
    items: [
      {
        name: "Lapo Martini",
        role: "DT Operations Leader, Baker Hughes",
        website: "https://www.linkedin.com/in/lapomartini/",
        image: "",
        quote: "La professionalità di Victor è eccezionale. Ha imparato a navigare in un ambiente complesso in pochi mesi e ha iniziato immediatamente a produrre risultati riconosciuti. Sarebbe una risorsa preziosa per qualsiasi team."
      },
      {
        name: "Luca Bauleo",
        role: "IT Manager, Pharma Line srl",
        website: "https://www.linkedin.com/in/lucabauleo/",
        image: "",
        quote: "Victor è stato una colonna portante del mio team IT. Di fronte a sfide complesse, ha sempre pronta una soluzione. La sua motivazione, il contagioso entusiasmo e la sua positività sono fonte d'ispirazione."
      },
      {
        name: "Fulvio Manno",
        role: "National Sales Manager, Pharma Line srl",
        website: "https://www.linkedin.com/in/fulvio-manno-b0035863/",
        image: "",
        quote: "Victor ha mostrato grande disponibilità e puntualità nel proporre servizi e applicazioni che migliorassero oggettivamente il nostro lavoro. Serietà ed empatia completano il suo profilo. Grazie per il supporto impagabile."
      },
      {
        name: "Marta Bolognino",
        role: "Formatrice & Consulente Marketing",
        website: "https://www.linkedin.com/in/martabolognino/",
        image: "",
        quote: "Ho capito subito che Victor è un ragazzo sveglio e molto preparato sul tema dell'intelligenza artificiale. Lo consiglio a chi vuole capire come funziona l'intelligenza artificiale."
      },
      {
        name: "Luca Adamo",
        role: "Docente di logistica",
        website: "https://www.linkedin.com/in/luca-adamo/",
        image: "",
        quote: "Un'esperienza estremamente positiva. Ha dimostrato grande professionalità e competenza. La sua attitudine a trovare soluzioni creative ed innovative ha arricchito il nostro lavoro di squadra."
      },
      {
        name: "CEO",
        role: "Salugea S.r.l.",
        website: "https://salugea.com/",
        image: "/images/testimonials/salugea-logo.png",
        quote: "Siamo rimasti colpiti dalla professionalità e disponibilità eccelsi di Victor. Le dashboard che ci ha creato sono già operative e a disposizione di tutte le funzioni aziendali."
      },
      {
        name: "Proprietario",
        role: "La Falegnameria SAS",
        website: "https://lafalegnameria-sas.it/",
        image: "",
        quote: "Victor ha svolto un lavoro eccezionale, aiutandoci a portare la nostra azienda nel mondo digitale. La sua professionalità, impegno ed eccellenza sono una garanzia di successo."
      },
      {
        name: "Titolare",
        role: "AV Infissi",
        website: "https://av-infissi.it/",
        image: "",
        quote: "La collaborazione con Victor ha trasformato il nostro modo di acquisire clienti, portandoci un aumento del 60% dei contatti qualificati in soli tre mesi."
      }
    ]
  },
  en: {
    title: "What Clients & Collaborators Say",
    subtitle: "Trusted by leaders in tech, pharma, manufacturing, and consulting.",
    items: [
      {
        name: "Lapo Martini",
        role: "DT Operations Leader, Baker Hughes",
        website: "https://www.linkedin.com/in/lapomartini/",
        image: "",
        quote: "Victor's professionalism is exceptional. He learned to navigate a complex environment in a few months and immediately began producing recognized results. He would be a valuable asset to any team."
      },
      {
        name: "Luca Bauleo",
        role: "IT Manager, Pharma Line srl",
        website: "https://www.linkedin.com/in/lucabauleo/",
        image: "",
        quote: "Victor was a pillar of my IT team. When faced with complex challenges, he always has a solution ready. His motivation, contagious enthusiasm, and positivity are a source of inspiration."
      },
      {
        name: "Fulvio Manno",
        role: "National Sales Manager, Pharma Line srl",
        website: "https://www.linkedin.com/in/fulvio-manno-b0035863/",
        image: "",
        quote: "Victor showed great availability and punctuality in proposing services and applications that objectively improved our work. Seriousness and empathy complete his profile. Thanks for the invaluable support."
      },
      {
        name: "Marta Bolognino",
        role: "Trainer & Marketing Consultant",
        website: "https://www.linkedin.com/in/martabolognino/",
        image: "",
        quote: "I immediately understood that Victor is bright and very prepared on artificial intelligence. I recommend him to anyone who wants to understand how AI works."
      },
      {
        name: "Luca Adamo",
        role: "Logistics Lecturer",
        website: "https://www.linkedin.com/in/luca-adamo/",
        image: "",
        quote: "An extremely positive experience. He demonstrated great professionalism and competence. His attitude of finding creative and innovative solutions enriched our teamwork."
      },
      {
        name: "CEO",
        role: "Salugea S.r.l.",
        website: "https://salugea.com/",
        image: "/images/testimonials/salugea-logo.png",
        quote: "We were impressed by Victor's excellent professionalism and availability. The dashboards he created are already operational and available to all business functions."
      },
      {
        name: "Owner",
        role: "La Falegnameria SAS",
        website: "https://lafalegnameria-sas.it/",
        image: "",
        quote: "Victor did an exceptional job helping us bring our company into the digital world. His professionalism, commitment, and excellence are a guarantee of success."
      },
      {
        name: "Owner",
        role: "AV Infissi",
        website: "https://av-infissi.it/",
        image: "",
        quote: "Working with Victor transformed how we acquire customers, bringing us a 60% increase in qualified leads in just three months."
      }
    ]
  }
};